import React from "react";
import { useLocation } from "react-router-dom";
import { CoachProgramLibraryHeaderFilters } from "../../../components/program-library/CoachProgramLibraryHeaderFilters";
import { ProgramListFilterContext } from "../../../contexts/ProgramLibraryFilterContext";
import { ProgramTemplateCategory } from "@growth-machine-llc/stridist-api-client";
import { AllOption, AllOptionType } from "../../../constants";
import { JourneyAnchors } from "../../../constants";
import { CoachLibraryLayout } from "./CoachLibraryLayout";
import {
  useLibraryFiltersState,
  BaseLibraryFilters,
} from "../../../hooks/useLibraryFilterState";
import { COACH_PROGRAM_LIBRARY_PUBLISHED_ROUTE } from "../../../routes/routes";

export interface ProgramLibraryFilters extends BaseLibraryFilters {
  category: ProgramTemplateCategory[] | AllOptionType;
}

const CoachProgramLibraryWrapper = () => {
  const location = useLocation();

  const {
    query,
    sortKey,
    filters,
    page,
    rowsPerPage,
    privacy,
    handleQueryChange,
    handleSortKeyChange,
    updateFilters,
    handlePageChange,
    handleRowsPerPageChange,
    handleChangePrivacy,
    handleResetFilters,
    filtersToReset,
  } = useLibraryFiltersState<ProgramLibraryFilters>({
    defaultFilters: {
      category: AllOption,
    },
    resetOn: location.pathname,
  });

  const { category } = filters;

  const handleCategoryChange = React.useCallback(
    (category: ProgramTemplateCategory[] | AllOptionType) => {
      // If all categories are selected, set to ALL_OPTIONS
      const allCategories = Object.values(ProgramTemplateCategory);
      const isAllSelected =
        Array.isArray(category) &&
        category.length === allCategories.length &&
        allCategories.every((c) => category.includes(c));

      updateFilters({
        category: isAllSelected ? AllOption : category,
      });
    },
    [updateFilters],
  );

  const filterContextValue = {
    query,
    sortKey,
    category,
    privacy,
    page,
    rowsPerPage,
    handleQueryChange,
    handleSortKeyChange,
    handleCategoryChange,
    handleChangePrivacy,
    handlePageChange,
    handleRowsPerPageChange,
  };

  return (
    <CoachLibraryLayout
      Provider={ProgramListFilterContext.Provider}
      providerValue={filterContextValue}
      maxWidth="xl"
      containerClassName={JourneyAnchors.PROGRAM_LIBRARY_TEMPLATES_LIST}
      header={
        <CoachProgramLibraryHeaderFilters
          query={query}
          onChangeQuery={handleQueryChange}
          privacy={privacy}
          onChangePrivacy={handleChangePrivacy}
          disabledResetButton={!filtersToReset}
          showResetButton={true}
          onResetFilters={handleResetFilters}
          defaultQuery=""
          showFilterByType={
            location.pathname == COACH_PROGRAM_LIBRARY_PUBLISHED_ROUTE
          }
        />
      }
    />
  );
};

export default CoachProgramLibraryWrapper;
